import React, { useState } from "react";
import {
  Box,
  Grid,
  Button,
  Typography,
  Paper,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { State, City } from "country-state-city";
import { UploadPropertyPageStyles } from "./UploadPropertyPage.styles";
import useFirebaseUpload from "../../hooks/useFirebaseUpload";
import PropertyDetailsForm from "./PropertyDetailsForm";
import FileUploadForm from "./FileUploadForm";
import PaymentModal from "./PaymentModal";
// import { useAuth } from "../../hooks/useAuth";
// import { getFirestore} from "firebase/firestore";

const UploadPropertyPage = () => {
  const [address, setAddress] = useState("");
  const [description, setDescription] = useState("");
  const [state, setState] = useState(null);
  const [city, setCity] = useState(null);
  const [listingLink, setListingLink] = useState("");
  const [applicationLink, setApplicationLink] = useState("");
  const [images, setImages] = useState([]);
  const userType = "owner";
  const [schedulingRestrictions, setSchedulingRestrictions] = useState("");
  const [specialInstructions, setSpecialInstructions] = useState("");
  const [loading, setLoading] = useState(false);
  // const [paymentCompleted, setPaymentCompleted] = useState(false);
  const [paymentModalOpen, setPaymentModalOpen] = useState(false);
  const [zip, setZip] = useState("");
  const [agentPhone, setAgentPhone] = useState("");

  const navigate = useNavigate();
  const { uploadProperty } = useFirebaseUpload();
  // const { currentUser } = useAuth();
  // const firestore = getFirestore();

  /* ---------- free listing entitlement ---------- */
  // const [hasFreeListings, setHasFreeListings] = useState(false);

  // useEffect(() => {
  //   if (!currentUser) return;
  //   (async () => {
  //     const snap = await getDoc(doc(firestore, "users", currentUser.uid));
  //     // const freeUntil = snap.data()?.freeListingUntil || 0;
  //     // setHasFreeListings(freeUntil > Date.now());
  //   })();
  // }, [currentUser, firestore]);

  const stateOptions = State.getStatesOfCountry("US").map((st) => ({
    value: st.isoCode,
    label: st.name,
  }));

  const cityOptions = state
    ? City.getCitiesOfState("US", state.value).map((ct) => ({
        value: ct.name,
        label: ct.name,
      }))
    : [];

  const resetForm = () => {
    setAddress("");
    setDescription("");
    // Hidden until PMS integration:
    // setPropertyType("");
    // setRent("");
    // setDeposit("");
    // setApplicationFee("");
    // setQualifyingCriteria("");
    setState(null);
    setCity(null);
    setListingLink("");
    setApplicationLink("");
    setImages([]);
    // userType is fixed to "owner"
    setSchedulingRestrictions("");
    setSpecialInstructions("");
    setZip("");
    setAgentPhone("");
  };

  const buildPropertyData = () => ({
    address: address.trim(),
    description,
    // Hidden until PMS integration - will be synced from property management software:
    // propertyType,
    // rent,
    // deposit,
    // applicationFee,
    // qualifyingCriteria,
    state: state?.label,
    city: city?.label,
    zip,
    listingLink,
    applicationLink,
    schedulingRestrictions,
    specialInstructions,
    agentPhone,
    // ✅ always send owner to backend
    userType: "owner",
  });

  const handlePaymentSuccess = async () => {
    // setPaymentCompleted(true);
    setLoading(true);
    try {
      await uploadProperty(buildPropertyData(), images);
      resetForm();
      // Redirect to dashboard listings tab after successful upload with success message
      navigate("/agent-dashboard?tab=listings", { state: { propertyAdded: true } });
    } catch (error) {
      alert("Failed to upload property.");
      console.error(error?.response?.data || error?.message || error);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // if (!hasFreeListings && !paymentCompleted) {
    //   setPaymentModalOpen(true);
    //   return;
    // }

    // if (hasFreeListings) {
    //   setPaymentCompleted(true);
    // }

    setLoading(true);
    try {
      await uploadProperty(buildPropertyData(), images);
      resetForm();
      // Redirect to dashboard listings tab after successful upload with success message
      navigate("/agent-dashboard?tab=listings", { state: { propertyAdded: true } });
    } catch (error) {
      alert("Failed to upload property.");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box sx={{ ...UploadPropertyPageStyles.pageContainer, mt: "2rem" }}>
      <Typography variant="h4" sx={{ mb: "1rem", textAlign: "center" }}>
        Add A Property
      </Typography>

      <Paper elevation={3} sx={{ p: "2rem", borderRadius: "10px" }}>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={3}>
            {/* 🔥 Removed Owner/Manager radio group entirely */}

            <PropertyDetailsForm
              {...{
                address,
                setAddress,
                zip,
                setZip,
                description,
                setDescription,
                // Hidden until PMS integration:
                // propertyType,
                // setPropertyType,
                // rent,
                // setRent,
                // deposit,
                // setDeposit,
                // applicationFee,
                // setApplicationFee,
                // qualifyingCriteria,
                // setQualifyingCriteria,
                state,
                setState,
                city,
                setCity,
                listingLink,
                setListingLink,
                applicationLink,
                setApplicationLink,
                schedulingRestrictions,
                setSchedulingRestrictions,
                setSpecialInstructions,
                specialInstructions,
                stateOptions,
                cityOptions,
                agentPhone,
                setAgentPhone,
              }}
            />

            {/* ⬇ FileUploadForm now only handles images */}
            <FileUploadForm
              {...{
                userType, // harmless to keep; can be removed if not used
                images,
                setImages,
              }}
            />

            <Grid item xs={12}>
              <Button
                type="submit"
                variant="contained"
                fullWidth
                disabled={loading}
                sx={UploadPropertyPageStyles.submitButton}
              >
                {loading ? "Submitting..." : "Submit Property"}
              </Button>
            </Grid>
            <Grid item xs={12}>
              <Button
                variant="outlined"
                fullWidth
                onClick={() => navigate("/agent-dashboard")}
                sx={UploadPropertyPageStyles.closeButton}
              >
                Close
              </Button>
            </Grid>
          </Grid>
        </form>
      </Paper>

      <PaymentModal
        open={paymentModalOpen}
        handleClose={() => setPaymentModalOpen(false)}
        onPaymentSuccess={handlePaymentSuccess}
      />
    </Box>
  );
};

export default UploadPropertyPage;


// import React, { useState, useEffect } from "react";
// import {
//   Box,
//   Grid,
//   Snackbar,
//   Alert,
//   Button,
//   Typography,
//   Paper,
//   Slide,              // ⬅ add
// } from "@mui/material";
// import { useNavigate } from "react-router-dom";
// import { State, City } from "country-state-city";
// import { UploadPropertyPageStyles } from "./UploadPropertyPage.styles";
// import useFirebaseUpload from "../../hooks/useFirebaseUpload";
// import PropertyDetailsForm from "./PropertyDetailsForm";
// import FileUploadForm from "./FileUploadForm";
// import PaymentModal from "./PaymentModal";
// import axios from "axios";
// import { useAuth } from "../../hooks/useAuth";
// import { getFirestore, doc, getDoc } from "firebase/firestore";

// function SlideDown(props) {
//   return <Slide {...props} direction="down" />;
// }

// const UploadPropertyPage = () => {
//   const [title, setTitle] = useState("");
//   const [address, setAddress] = useState("");
//   const [description, setDescription] = useState("");
//   const [propertyType, setPropertyType] = useState("");
//   const [rent, setRent] = useState("");
//   const [state, setState] = useState(null);
//   const [city, setCity] = useState(null);
//   const [deposit, setDeposit] = useState("");
//   const [applicationFee, setApplicationFee] = useState("");
//   const [applicationLink, setApplicationLink] = useState("");
//   const [images, setImages] = useState([]);
//   const [proofOfOwnership, setProofOfOwnership] = useState(null);
//   const [managementAgreement, setManagementAgreement] = useState(null);
//   // 🔒 lock it to "owner"
//   const userType = "owner";
//   const [qualifyingCriteria, setQualifyingCriteria] = useState("");
//   const [schedulingRestrictions, setSchedulingRestrictions] = useState("");
//   const [specialInstructions, setSpecialInstructions] = useState("");
//   const [loading, setLoading] = useState(false);
//   const [successAlert, setSuccessAlert] = useState(false);
//   const [paymentCompleted, setPaymentCompleted] = useState(false);
//   const [paymentModalOpen, setPaymentModalOpen] = useState(false);
//   const [zip, setZip] = useState("");
//   const [agentPhone, setAgentPhone] = useState("");

//   const navigate = useNavigate();
//   const { uploadProperty } = useFirebaseUpload();
//   const { currentUser } = useAuth();
//   const firestore = getFirestore();

//   /* ---------- free listing entitlement ---------- */
//   const [hasFreeListings, setHasFreeListings] = useState(false);

//   useEffect(() => {
//     if (!currentUser) return;
//     (async () => {
//       const snap = await getDoc(doc(firestore, "users", currentUser.uid));
//       const freeUntil = snap.data()?.freeListingUntil || 0;
//       setHasFreeListings(freeUntil > Date.now());
//     })();
//   }, [currentUser, firestore]);

//   const stateOptions = State.getStatesOfCountry("US").map((st) => ({
//     value: st.isoCode,
//     label: st.name,
//   }));

//   const cityOptions = state
//     ? City.getCitiesOfState("US", state.value).map((ct) => ({
//         value: ct.name,
//         label: ct.name,
//       }))
//     : [];

//   const resetForm = () => {
//     setTitle("");
//     setAddress("");
//     setDescription("");
//     setPropertyType("");
//     setRent("");
//     setState(null);
//     setCity(null);
//     setDeposit("");
//     setApplicationFee("");
//     setApplicationLink("");
//     setImages([]);
//     setProofOfOwnership(null);
//     setManagementAgreement(null);
//     // userType is fixed to "owner"
//     setQualifyingCriteria("");
//     setSchedulingRestrictions("");
//     setSpecialInstructions("");
//     setZip("");
//     setAgentPhone("");
//   };

//   const buildPropertyData = () => ({
//     title,
//     address: address.trim(),
//     description,
//     propertyType,
//     rent,
//     state: state?.label,
//     city: city?.label,
//     zip,
//     deposit,
//     applicationFee,
//     applicationLink,
//     qualifyingCriteria,
//     schedulingRestrictions,
//     specialInstructions,
//     agentPhone,
//     // ✅ always send owner to backend
//     userType: "owner",
//   });

//   const maybeSendProofEmail = async () => {
//     if (!proofOfOwnership) return;
//     const formData = new FormData();
//     formData.append("files", proofOfOwnership);
//     formData.append("to", "theeseus@protonmail.com");
//     formData.append("subject", "New Property Document");
//     formData.append("text", "Here’s the uploaded property document.");
//     await axios.post("https://ai-realtor.onrender.com/send-email", formData, {
//       headers: { "Content-Type": "multipart/form-data" },
//     });
//   };

//   const handlePaymentSuccess = async () => {
//     setPaymentCompleted(true);
//     setLoading(true);
//     try {
//       await uploadProperty(buildPropertyData(), images, proofOfOwnership);
//       await maybeSendProofEmail();
//       setSuccessAlert(true);
//       resetForm();
//     } catch (error) {
//       alert("Failed to upload property or send email.");
//       console.error(error.response?.data || error.message);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!hasFreeListings && !paymentCompleted) {
//       setPaymentModalOpen(true);
//       return;
//     }

//     if (hasFreeListings) {
//       setPaymentCompleted(true);
//     }

//     setLoading(true);
//     try {
//       await uploadProperty(buildPropertyData(), images, proofOfOwnership);
//       await maybeSendProofEmail();
//       setSuccessAlert(true);
//       resetForm();
//     } catch (error) {
//       alert("Failed to upload property or send email.");
//       console.error(error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleViewListings = () => {
//     setSuccessAlert(false);
//     navigate("/agent-dashboard?tab=listings");
//   };

//   return (
//     <Box sx={{ ...UploadPropertyPageStyles.pageContainer, mt: "2rem" }}>
//       <Typography variant="h4" sx={{ mb: "1rem", textAlign: "center" }}>
//         Add A Property
//       </Typography>

//       <Paper elevation={3} sx={{ p: "2rem", borderRadius: "10px" }}>
//         <form onSubmit={handleSubmit}>
//           <Grid container spacing={3}>
//             {/* 🔥 Removed Owner/Manager radio group entirely */}

//             <PropertyDetailsForm
//               {...{
//                 title,
//                 setTitle,
//                 address,
//                 setAddress,
//                 zip,
//                 setZip,
//                 description,
//                 setDescription,
//                 propertyType,
//                 setPropertyType,
//                 rent,
//                 setRent,
//                 state,
//                 setState,
//                 city,
//                 setCity,
//                 deposit,
//                 setDeposit,
//                 applicationFee,
//                 setApplicationFee,
//                 applicationLink,
//                 setApplicationLink,
//                 qualifyingCriteria,
//                 setQualifyingCriteria,
//                 schedulingRestrictions,
//                 setSchedulingRestrictions,
//                 specialInstructions,
//                 setSpecialInstructions,
//                 stateOptions,
//                 cityOptions,
//                 agentPhone,
//                 setAgentPhone,
//               }}
//             />

//             <FileUploadForm
//               {...{
//                 userType, // stays "owner" so FileUploadForm can keep any conditional UI
//                 proofOfOwnership,
//                 setProofOfOwnership,
//                 managementAgreement,
//                 setManagementAgreement,
//                 images,
//                 setImages,
//               }}
//             />

//             <Grid item xs={12}>
//               <Button
//                 type="submit"
//                 variant="contained"
//                 fullWidth
//                 disabled={loading}
//                 sx={UploadPropertyPageStyles.submitButton}
//               >
//                 {loading ? "Submitting..." : "Submit Property"}
//               </Button>
//             </Grid>
//             <Grid item xs={12}>
//               <Button
//                 variant="outlined"
//                 fullWidth
//                 onClick={() => navigate("/agent-dashboard")}
//                 sx={UploadPropertyPageStyles.closeButton}
//               >
//                 Close
//               </Button>
//             </Grid>
//           </Grid>
//         </form>
//       </Paper>

//       <PaymentModal
//         open={paymentModalOpen}
//         handleClose={() => setPaymentModalOpen(false)}
//         onPaymentSuccess={handlePaymentSuccess}
//       />

//       {/* ✅ Improved success message */}
//       <Snackbar
//         open={successAlert}
//         autoHideDuration={7000}
//         onClose={() => setSuccessAlert(false)}
//         anchorOrigin={{ vertical: "top", horizontal: "center" }}
//         TransitionComponent={SlideDown}
//       >
//         <Alert
//           onClose={() => setSuccessAlert(false)}
//           severity="success"
//           variant="filled"
//           sx={{
//             width: "100%",
//             fontWeight: 600,
//             boxShadow: 3,
//           }}
//           action={
//             <Button
//               color="inherit"
//               size="small"
//               onClick={handleViewListings}
//               sx={{ fontWeight: 700 }}
//             >
//               View listings
//             </Button>
//           }
//         >
//           Your property was uploaded successfully. We’ve also sent your document (if provided). 🎉
//         </Alert>
//       </Snackbar>
//     </Box>
//   );
// };

// export default UploadPropertyPage;
